import { useMutation as useReactQueryMutation } from '@tanstack/react-query'

import { useClient } from '../useClient/useClient'

import { UseMutationProps } from './useMutation.types'

export const useMutation = <TData = unknown, TError = unknown, TVariables extends object = {}, TContext = unknown>({
  mutationFn,
  onSuccess,
  onError,
  mutationKey
}: UseMutationProps<TVariables, TData, TError>) => {
  const { gsClient } = useClient()

  const result = useReactQueryMutation<TData, TError, TVariables, TContext>({
    mutationKey,
    mutationFn: variables => mutationFn(gsClient, variables),
    onSuccess,
    onError
  })

  return { ...result, isLoading: result.isPending }
}
